import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import SourceIdField from './components/SourceIdField';
import IsvSourceIdField from './components/IsvSourceIdField';
import IsvPercenField from './components/IsvPercenField';
import IsvFixedFeeAmountField from './components/IsvFixedFeeAmountField';
import IsvFixedFeeThresholdField from './components/IsvFixedFeeThresholdField';
import PinCodeField from './components/PinCodeField';
import FranchisePercentField from './components/FranchisePercentField';
import FranchiseFixedFeeAmountField from './components/FranchiseFixedFeeAmountField';
import FranchiseFixedFeeThresholdField from './components/FranchiseFixedFeeThresholdField';
import style from './VivaWallet.module.scss';

const VivaWallet: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const hasFranchise = restaurantForFullInfo?.vivaWalletIsv?.franchiseCommission != null;

	return (
		<>
			{restaurantForFullInfo?.additionalApplications.includes('VivaWallet') && (
				<>
					<div className={style.heading}>
						<Text
							translationNameSpace="form"
							translationKey="vivaWalletConfigurationFieldsHeading"
							theme="secondary"
							size="s"
							weight="bold"
							display="inline"
						/>
					</div>
					<div className={style.row}>
						<SourceIdField />
						<IsvSourceIdField />
					</div>
					<div className={style.row}>
						<IsvPercenField />
						<IsvFixedFeeAmountField />
					</div>
					<div className={style.row}>
						<IsvFixedFeeThresholdField />
						<PinCodeField />
					</div>
					{hasFranchise && (
						<>
							<div className={style.row}>
								<FranchisePercentField />
								<FranchiseFixedFeeAmountField />
							</div>
							<div className={style.row}>
								<FranchiseFixedFeeThresholdField />
								<div />
							</div>
						</>
					)}
				</>
			)}
		</>
	);
};

export default VivaWallet;
